export function parseBool(input: string, defaultValue: boolean = false): boolean {
	if (!input) return defaultValue;

	if (input.toLowerCase() === "true") return true;
	if (input === "1") return true;

	return defaultValue;
}
